import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";

import UserRoles from "constants/UserRoles";
import moment from "moment";
import ScheduleHeader from "../../../../../components/Parts/ScheduleHeader";


const breadcrumbsStatic = [{
	name: 'Dispatch',
	url: '/dispatch',
	icon: 'dashboard',
}];

export default class DispatcherSchedules extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state.currentView = 'day';
		this.state.currentDay = moment().format('dddd');
		this.state.filterWeek = moment().day(0).format('YYYY-MM-DD');
	}

	render() {
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "Schedules",
				url: `/dispatch/dispatchschedules`,
				icon: 'laptop',
			}
		]);
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					<div style={{width: "65vw"}}>
						<ScheduleHeader parent={this} roles={this.props.roles} type={"Dispatch"}/>
					</div>
				</Framework.Components.PageBar>
				<Collections.SchedulesComponent
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					currentView={this.state.currentView}
					currentDay={this.state.currentDay}
					filterWeek={this.state.filterWeek}
					override={"GET_DISPATCH"}
					roles={this.props.roles}
					key={this.state.key}
				/>
			</div>
		);
	}
}


